import { chat } from '../../stores/chat';
import { ChatSocket } from '../../hooks/use-socket';
import { ChatCommon } from '../../types/bingo-events/in/chat/common';

export const onMute = (socket: ChatSocket) => {
    const callback = (response: ChatCommon) => {
        if (response.message) {
            chat.messages.merge([
                {
                    message: response.message,
                    isSystemMsg: true,
                    isWelcomeMsg: false,
                },
            ]);
        }
    };

    socket.on('mute:parlay', callback);

    return () => {
        socket.off('mute:parlay', callback);
    };
};
